import { useEffect, useMemo } from 'react'

const useBroadcastChannel = (channelName: string) => {
  const channel = useMemo(() => {
    return typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(channelName) : null
  }, [channelName])

  useEffect(() => {
    // tab receiving update event initiated from another tab and reload
    if (channel) {
      channel!.onmessage = (event) => {
        if (event.data === 'update') {
          window.location.reload()
        }
      }
    }

    return () => channel?.close()
  }, [channel])

  // tab initiating update and reload
  const refreshAppTabs = () => {
    channel?.postMessage('update')
    window.location.reload()
  }

  return { refreshAppTabs }
}

export default useBroadcastChannel
